import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	card: {
		padding: "24px",
		boxShadow: "none"
	},
	cardTitle: {
		fontSize: "32px",
		fontWeight: 700
	},
	cardSubtitle: {
		fontSize: "16px",
		marginTop: "8px",
		color: "inherit"
	},
	purple: {
		color: newColors.purple[600],
		background: newColors.purple[100]
	},
	green: {
		color: newColors.green[600],
		background: newColors.green[100]
	},
	blue: {
		color: newColors.blue[600],
		background: newColors.blue[100]
	}
}))

export default useStyles
